import { ROLE_ADMIN } from "access-roles/roles";

export const enableValidateConsultantEmail = ({ roles, emailValidated }) =>
  roles.includes(ROLE_ADMIN) && !emailValidated;
